import { useEffect, useState } from "react";
import sanityClient from "../src/client.js";
import imageUrlBuilder from '@sanity/image-url'
import LinkCard from "./LinkCard.jsx";
import { formatDate } from "../functions/formatDate.jsx";

const POST_QUERY = `
*[
    _type == "Share"
  ] {
  slug,
  title,
  "category": category[0]->title,
  content,
  url,
  date,
  mainImage
  }
    | order(date desc) 
  `
export default function LinksGrid(){
    const [posts, setPosts] = useState(null);
    let renderedPosts

    useEffect(() => {
        sanityClient.fetch(POST_QUERY,{}, {
            cache: 'force-cache',
            next: { revalidate: 30}
        })
        .then((data) => setPosts(data))
        .catch(console.error)
    },[])
    
    

    
    if (posts) {
        renderedPosts = posts.map(post =>{
            return (
                <LinkCard
                    key={post.slug.current}
                    intLink={post.slug.current}
                    title={post.title} 
                    text={post.content[0].children[0].text} 
                    category={post.category}
                    url={post.url}
                    date={formatDate(post.date)}
                    image={imageUrlBuilder(sanityClient).image(post.mainImage).fit('clip').width(400).height(400).url()}
                    
                />
            )
        })
    }

    return <>
            <div className="container">
                <h1>Links</h1>
                <div className="link-grid">
                    {renderedPosts}
                </div>
            </div>        
    </>
    
}